export enum AncillaryBundleItemType {
  Bundle = 'Bundle',
  CancelForAnyReason = 'CancelForAnyReason',
  PremiumDisruptionAssistance = 'PremiumDisruptionAssistance',
  None = 'None',
}
